//components
import { Container } from '@/components/Grid';

//styles
import {
  FaqSection,
  FaqTitle,
  FaqList,
  FaqItem,
  FaqQuestion,
  FaqAnswer,
} from './FAQ.styles';

export function FAQ({ content }) {
  return (
    <FaqSection id="faq">
      <Container>
        <FaqTitle>{content.title}</FaqTitle>
        <FaqList>
          {content.items.map((item) => (
            <FaqItem key={item.question}>
              <FaqQuestion>{item.question}</FaqQuestion>
              <FaqAnswer>{item.answer}</FaqAnswer>
            </FaqItem>
          ))}
        </FaqList>
      </Container>
    </FaqSection>
  );
}
